import { createContext, useContext, useState, useEffect } from "react";
import { toast } from "sonner";
import { trackEvent } from "../lib/analytics";

const CartContext = createContext(null);
const KEY = "ata_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, variant = null) => {
    const price = variant ? (variant.discount_price ?? variant.price) : (product.discount_price ?? product.price);
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.product_id && i.variant === (variant?.name || null));
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [...prev, {
        product_id: product.product_id, slug: product.slug, name: product.name,
        image: product.images?.[0] || "", price, variant: variant?.name || null,
        vat_rate: product.vat_rate ?? 1, quantity, stock: product.stock,
        unit: product.base_unit || product.unit || "",
      }];
    });
    toast.success(`${product.name} sepete eklendi`);
    trackEvent("add_to_cart", { currency: "TRY", value: Math.round(price * quantity * 100) / 100, items: [{ item_id: product.product_id, item_name: product.name, price, quantity }] });
  };

  const setQty = (product_id, variant, quantity) => {
    if (quantity < 1) return;
    setItems((prev) => prev.map((i) => (i.product_id === product_id && i.variant === variant ? { ...i, quantity } : i)));
  };

  const removeItem = (product_id, variant) => {
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.variant === variant)));
  };

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, setQty, removeItem, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
